import { Dispatch } from 'react';
import { EntityFormReducerAction, EntityFormReducerActionType } from './interfaces';

export interface EntityFormReducerActions {
  initTestConnection: VoidFunction;
  saveTestConnectionError: (error: string) => void;
  saveTestConnectionSuccess: VoidFunction;
  saveForm: VoidFunction;
  saveFormError: (error: string) => void;
  saveTestConnectionTaskId: (taskId: string) => void;
  submitForm: VoidFunction;
}

export function EntityFormReducerActionsFactory(
  dispatch: Dispatch<EntityFormReducerAction>
): EntityFormReducerActions {
  return {
    initTestConnection: () => dispatch({ type: EntityFormReducerActionType.INIT_TEST_CONNECTION }),
    saveForm: () => dispatch({ type: EntityFormReducerActionType.SAVE_FORM }),
    saveTestConnectionError: (error: string) =>
      dispatch({
        type: EntityFormReducerActionType.SAVE_TEST_CONNECTION_ERROR,
        data: { testConnectionError: error }
      }),
    saveTestConnectionSuccess: () =>
      dispatch({
        type: EntityFormReducerActionType.SAVE_TEST_CONNECTION_SUCCESS
      }),
    saveTestConnectionTaskId: (taskId: string) =>
      dispatch({
        type: EntityFormReducerActionType.SAVE_TEST_CONNECTION_TASK_ID,
        data: {
          testConnectionTaskId: taskId
        }
      }),
    saveFormError: (error: string) =>
      dispatch({
        type: EntityFormReducerActionType.SAVE_FORM_ERROR,
        data: {
          saveFormError: error
        }
      }),
    submitForm: () =>
      dispatch({
        type: EntityFormReducerActionType.SUBMIT_FORM
      })
  };
}
